import React from "react";
import {
  Box,
  TextField,
  Button,
  IconButton,
  ToggleButtonGroup,
  ToggleButton,
  InputAdornment,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import IosShareIcon from "@mui/icons-material/IosShare";
import SearchIcon from "@mui/icons-material/Search";

const OrderFilters = ({
  searchTerm,
  setSearchTerm,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onExport,
  hasOrders,
  reviewedFilter,
  setReviewedFilter,
}) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2, flexWrap: "wrap" }}>

      {/* Search */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: 240,
          border: "1px solid rgba(0,0,0,0.18)",
          borderRadius: "8px",
          bgcolor: "white",
          height: 40,
          px: 1.2,
          "&:focus-within": { borderColor: "#1976d2", boxShadow: "0 0 0 2px rgba(25,118,210,0.12)" },
          transition: "box-shadow 0.15s, border-color 0.15s",
        }}
      >
        <SearchIcon sx={{ color: "text.disabled", fontSize: 18, mr: 0.8, flexShrink: 0 }} />
        <input
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="חיפוש..."
          style={{
            flex: 1,
            border: "none",
            outline: "none",
            fontSize: "0.875rem",
            background: "transparent",
            color: "inherit",
            fontFamily: "inherit",
            minWidth: 0,
          }}
        />
        {searchTerm && (
          <IconButton size="small" onClick={() => setSearchTerm("")} sx={{ p: 0.3 }}>
            <ClearIcon fontSize="small" sx={{ color: "text.disabled" }} />
          </IconButton>
        )}
      </Box>

      {/* Status filter pills */}
      <ToggleButtonGroup
        value={reviewedFilter}
        exclusive
        onChange={(_, val) => val && setReviewedFilter(val)}
        sx={{
          bgcolor: "rgba(0,0,0,0.05)",
          borderRadius: "8px",
          p: "3px",
          "& .MuiToggleButtonGroup-grouped": {
            border: "none !important",
            borderRadius: "5px !important",
            px: 1.5,
            py: 0,
            height: 30,
            fontSize: "0.78rem",
            fontWeight: 500,
            textTransform: "none",
            color: "text.secondary",
          },
        }}
      >
        <ToggleButton value="all" sx={{ "&.Mui-selected": { bgcolor: "white", color: "text.primary", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" } }}>
          הכל
        </ToggleButton>
        <ToggleButton value="pending" sx={{ "&.Mui-selected": { bgcolor: "#dbeafe", color: "#1e40af" } }}>
          חדשים
        </ToggleButton>
        <ToggleButton value="reviewed" sx={{ "&.Mui-selected": { bgcolor: "#fef3c7", color: "#92400e" } }}>
          ממתינים
        </ToggleButton>
      </ToggleButtonGroup>

      {/* Spacer */}
      <Box sx={{ flex: 1 }} />

      {/* Date range */}
      <TextField
        label="מתאריך"
        type="date"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: startDate && (
            <InputAdornment position="end">
              <IconButton size="small" onClick={() => setStartDate("")} edge="end">
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        size="small"
        sx={{ width: 155 }}
      />
      <TextField
        label="עד תאריך"
        type="date"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: endDate && (
            <InputAdornment position="end">
              <IconButton size="small" onClick={() => setEndDate("")} edge="end">
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        size="small"
        sx={{ width: 155 }}
      />

      {/* Export */}
      {hasOrders && (
        <Button
          variant="contained"
          startIcon={<IosShareIcon fontSize="small" />}
          onClick={onExport}
          size="small"
          sx={{
            bgcolor: "#217346",
            "&:hover": { bgcolor: "#1e6f42" },
            whiteSpace: "nowrap",
            height: 40,
          }}
        >
          Excel
        </Button>
      )}
    </Box>
  );
};

export default OrderFilters;
